// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    title: {
        id: "apps.assistantChat.components.title",
        description: "Title.",
        defaultMessage: "Snap Assistant",
    },
    fabAriaLabel: {
        id: "apps.assistantChat.components.fabAriaLabel",
        description: "Fab aria label.",
        defaultMessage: "Open Snap Assistant",
    },
    closeAriaLabel: {
        id: "apps.assistantChat.components.closeAriaLabel",
        description: "Close aria label.",
        defaultMessage: "Close Snap Assistant",
    },
    startOverAriaLabel: {
        id: "apps.assistantChat.components.startOverAriaLabel",
        description: "Start over aria label.",
        defaultMessage: "Start over",
    },
    contextChip: {
        id: "apps.assistantChat.components.contextChip",
        description: "Context chip.",
        defaultMessage: "On {page}",
    },
    confirmRestartTitle: {
        id: "apps.assistantChat.components.confirmRestartTitle",
        description: "Confirm restart title.",
        defaultMessage: "Stop this answer and start over?",
    },
    confirmRestartCancel: {
        id: "apps.assistantChat.components.confirmRestartCancel",
        description: "Confirm restart cancel.",
        defaultMessage: "Cancel",
    },
    confirmRestartConfirm: {
        id: "apps.assistantChat.components.confirmRestartConfirm",
        description: "Confirm restart confirm.",
        defaultMessage: "Start over",
    },
    ephemeralNote: {
        id: "apps.assistantChat.components.ephemeralNote",
        description: "Ephemeral note.",
        defaultMessage: "Conversations aren't saved — start over anytime",
    },
    genAiDisclaimer: {
        id: "apps.assistantChat.components.genAiDisclaimer",
        description: "Gen ai disclaimer.",
        defaultMessage:
            "This tool is powered by GenAI. Please verify the output with the provided sources and do not enter any sensitive information.",
    },
    emptyHeadline: {
        id: "apps.assistantChat.components.emptyHeadline",
        description: "Empty headline.",
        defaultMessage: "Hi! How can I help?",
    },
    emptyBody: {
        id: "apps.assistantChat.components.emptyBody",
        description: "Empty body.",
        defaultMessage:
            "Ask about submitting and managing lenses, monetization, asset library, analytics, or anything else from the docs.",
    },
    suggestedEyebrow: {
        id: "apps.assistantChat.components.suggestedEyebrow",
        description: "Suggested eyebrow.",
        defaultMessage: "SUGGESTED",
    },
    suggestDefault1: {
        id: "apps.assistantChat.components.suggestDefault1",
        description: "Suggest default1.",
        defaultMessage: "How do I submit a lens for review?",
    },
    suggestDefault2: {
        id: "apps.assistantChat.components.suggestDefault2",
        description: "Suggest default2.",
        defaultMessage: "What can I do in My Lenses?",
    },
    suggestDefault3: {
        id: "apps.assistantChat.components.suggestDefault3",
        description: "Suggest default3.",
        defaultMessage: "Why was my lens rejected?",
    },
    suggestInsights1: {
        id: "apps.assistantChat.components.suggestInsights1",
        description: "Suggest insights1.",
        defaultMessage: "Why did my lens views drop this week?",
    },
    suggestInsights2: {
        id: "apps.assistantChat.components.suggestInsights2",
        description: "Suggest insights2.",
        defaultMessage: "Which metrics matter most for my lenses?",
    },
    suggestInsights3: {
        id: "apps.assistantChat.components.suggestInsights3",
        description: "Suggest insights3.",
        defaultMessage: "How do I read my lens analytics?",
    },
    suggestSubmit1: {
        id: "apps.assistantChat.components.suggestSubmit1",
        description: "Suggest submit1.",
        defaultMessage: "What are the lens submission requirements?",
    },
    suggestSubmit2: {
        id: "apps.assistantChat.components.suggestSubmit2",
        description: "Suggest submit2.",
        defaultMessage: "Why is my submission stuck in review?",
    },
    suggestSubmit3: {
        id: "apps.assistantChat.components.suggestSubmit3",
        description: "Suggest submit3.",
        defaultMessage: "How long does lens review take?",
    },
    suggestAssets1: {
        id: "apps.assistantChat.components.suggestAssets1",
        description: "Suggest assets1.",
        defaultMessage: "What asset formats does My Lenses support?",
    },
    suggestAssets2: {
        id: "apps.assistantChat.components.suggestAssets2",
        description: "Suggest assets2.",
        defaultMessage: "How do I organize my asset library?",
    },
    suggestAssets3: {
        id: "apps.assistantChat.components.suggestAssets3",
        description: "Suggest assets3.",
        defaultMessage: "What are remote assets used for?",
    },
    suggestLenses1: {
        id: "apps.assistantChat.components.suggestLenses1",
        description: "Suggest lenses1.",
        defaultMessage: "How do I manage and update my lenses?",
    },
    suggestLenses2: {
        id: "apps.assistantChat.components.suggestLenses2",
        description: "Suggest lenses2.",
        defaultMessage: "How do I unpublish a lens?",
    },
    suggestLenses3: {
        id: "apps.assistantChat.components.suggestLenses3",
        description: "Suggest lenses3.",
        defaultMessage: "How do I share a lens link?",
    },
    inputPlaceholder: {
        id: "apps.assistantChat.components.inputPlaceholder",
        description: "Input placeholder.",
        defaultMessage: "Ask a question…",
    },
    sendAriaLabel: {
        id: "apps.assistantChat.components.sendAriaLabel",
        description: "Send aria label.",
        defaultMessage: "Send",
    },
    thinkingAriaLabel: {
        id: "apps.assistantChat.components.thinkingAriaLabel",
        description: "Thinking aria label.",
        defaultMessage: "Generating response",
    },
    errorFallback: {
        id: "apps.assistantChat.components.errorFallback",
        description: "Error fallback.",
        defaultMessage: "Sorry, something went wrong. Please try again.",
    },
    sourcesMoreAriaLabel: {
        id: "apps.assistantChat.components.sourcesMoreAriaLabel",
        description: "Sources more aria label.",
        defaultMessage: "Show {count} more sources",
    },
});
